
import { FC, useContext } from "react";
import { SpinProps } from "antd";

import { Spinner } from "../../../../../../shared/components";

import { GenericDataFormContext } from "../../contexts/GenericDataForm";

interface SpinnerPreliquidationProps {
    children: React.ReactNode;
    spinnerProps?: SpinProps;
}

export const SpinnerPreliquidation: FC<SpinnerPreliquidationProps> = ({children, spinnerProps}) => {
  const { canShowSpinner, loadingSavedPreliquidation } = useContext(GenericDataFormContext)

  return <Spinner spinnerProps={{...spinnerProps, spinning: canShowSpinner || loadingSavedPreliquidation }} >{children}</Spinner>
}

